(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.information-section');
  
  if (!section) return;
  
  // Force text colors with JavaScript
  const textColor = '{{ section.settings.section_text_color | default: "#333333" }}';
  const linkColor = '{{ section.settings.link_color | default: "#E18700" }}';
  
  // Override all text colors
  const forceTextColor = () => {
    const textElements = section.querySelectorAll('.information-section__article-date, .information-section__article-excerpt, .information-section__article-tags, .information-section__article-title, .information-section__article p, .information-section__article a, .information-section__title');
    textElements.forEach(element => {
      if (!element.classList.contains('information-section__link--hashtag')) {
        element.style.setProperty('color', textColor, 'important');
      }
    });
    
    // Set hashtag links to link color
    const hashtagLinks = section.querySelectorAll('.information-section__link--hashtag');
    hashtagLinks.forEach(link => {
      link.style.setProperty('color', linkColor, 'important');
    });
  };
  
  // Call multiple times to ensure it takes effect
  forceTextColor();
  setTimeout(forceTextColor, 100);
  setTimeout(forceTextColor, 500);
  
  // Override button colors
  const button = section.querySelector('.information-section__view-all-bottom');
  if (button) {
    button.style.color = textColor + ' !important';
    button.style.borderColor = textColor + ' !important';
  }
  
  // Ensure mobile layout works correctly
  const checkMobileLayout = function() {
    if (window.innerWidth <= 768) {
      const smallArticlesContainer = section.querySelector('.information-section__small-articles');
      if (smallArticlesContainer) {
        smallArticlesContainer.style.display = 'grid';
        smallArticlesContainer.style.gridTemplateColumns = '1fr 1fr';
      }
    }
  };
  
  // Run on load and resize
  checkMobileLayout();
  window.addEventListener('resize', checkMobileLayout);
  
  // Make hashtag links work properly on mobile
  const allLinks = section.querySelectorAll('a');
  allLinks.forEach(link => {
    link.addEventListener('touchend', function(e) {
      if (this.getAttribute('href') === '#') {
        e.preventDefault();
      }
    });
  });
  
  // Ensure images load properly
  const allImages = section.querySelectorAll('.information-section__article-image');
  allImages.forEach(img => {
    img.addEventListener('error', function() {
      this.src = '{{ "placeholder-image.jpg" | asset_url }}';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
